import type { CertGenParams } from '@yandex-int/k-common';

export const TeacherDiagInfAutumn2022 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
}: CertGenParams) => {
    return `<!DOCTYPE html>
<html lang="ru">
<head>
    <title>Сертификат за диагностику в Информатике</title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <style>
        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
            font-weight: 300;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
            font-weight: 400;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
            font-weight: 500;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Text';
            src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
            url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
            font-weight: bold;
            font-style: normal;
        }

        @font-face {
            font-family: 'YS Display';
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;

            src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
            url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
        }

        @font-face {
            font-family: 'YS Display';
            font-weight: 800;
            font-style: normal;
            font-stretch: normal;

            src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
            url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
        }

        @page {
            size: 210mm 297mm;
            margin: 0;
            padding: 0;
        }

        @media print {
            html,
            body {
                width: 210mm;
                height: 297mm;

                box-sizing: border-box;
            }
        }

        html {
            position: relative;

            margin: 0;
            padding: 0;

            --background-color: #ffffff;
            --text-color: #000000
        }

        body {
            margin: 0;

            color: var(--text-color);

            font-family: 'YS Text', sans-serif;
        }

        .page {
            position: relative;

            overflow: hidden;

            box-sizing: border-box;

            width: 210mm;
            height: 297mm;

            background: var(--background-color);

            page-break-after: always;
        }

        .page__background {
            position: absolute;

            width: 100%;
            height: 100%;

            overflow: hidden;

            display: flex;

            z-index: 1;
        }

        .page__content {
            height: 100%;
            width: 100%;
        }

        .content {
            box-sizing: border-box;

            display: flex;

            z-index: 2;
        }

        .page__rectangle {
            overflow: hidden;

            position: relative;

            height: 100%;
            width: calc(210 / 595 * 196mm);

            background-color: #D8B1FF;
        }

        .page__paragraph {
            position: absolute;

            top: calc(297 / 842 * 34mm);
        }

        .paragraph {
            width: 100%;
            height: 100%;
        }

        .page__paragraph_white {
            left: calc(297 / 842 * 40mm);

            width: calc(210 / 595 * 200mm);
            height: calc(297 / 842 * 495mm);
        }

        .page__paragraph_purple {
            left: calc(297 / 842 * 40mm);

            width: calc(210 / 595 * 200mm);
            height: calc(297 / 842 * 495mm);
        }

        .page__pc {
            position: absolute;

            bottom: calc(297 / 842 * -3mm);
            left: 0;

            width: calc(210 / 595 * 278mm);
        }

        .pc {
            width: 100%;
            height: 100%;
        }

        .page__line {
            position: absolute;

            height: 297mm;
            width: 210mm;
        }

        .line {
            width: 100%;
            height: 100%;
        }

        .content {
            display: flex;
            flex-direction: column;

            width: calc(210 / 595 * 240mm);

            margin-left:  calc(210 / 595 * 300mm);
            margin-top: calc(297 / 842 * 32mm);

            color: var(--text-color);
        }

        .content__logo {
            width: calc(210 / 595 * 168mm);
            height: calc(297 / 842 * 32mm);
        }

        .logo {
            width: 100%;
        }

        .content__title {
            height: calc(297 / 842 * 28mm);;

            margin-top: calc(297 / 842 * 48mm);

            font-family: 'YS Display', 'Arial', sans-serif;
            font-weight: 700;
            font-size: 20pt;
            line-height: 24pt;
            text-transform: uppercase;
        }

        .content__subtitle {
            font-family: 'YS Text', 'Arial', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 10pt;
            line-height: 130%;
        }

        .content__personal-info {
            margin-top: calc(297 / 842 * 48mm);
        }

        .personal-info {
            display: flex;
            flex-direction: column;

            height: calc(297 / 842 * 166mm);
        }

        .personal-info__name {
            font-family: 'YS Display', 'Arial', sans-serif;
            font-weight: 700;
            font-size: 18pt;
            line-height: 120%;
        }

        .personal-info__school {
            margin-top: calc(297 / 842 * 8mm);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 10pt;
            line-height: 130%;
        }

        .content__description {
            margin-top: calc(297 / 842 * 48mm);
        }

        .description {
            display: flex;
            flex-direction: column;

            height: calc(297 / 842 * 112mm);
        }

        .description__title {
            font-family: 'YS Display', 'Arial', sans-serif;
            font-weight: 400;
            font-size: 16pt;
            line-height: 120%;
        }

        .description__text {
            margin-top: calc(297 / 842 * 8mm);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 10pt;
            line-height: 130%;
        }

        .content__footer {
            margin-top: calc(297 / 842 * 148mm);
        }

        .footer {
            position: relative;

            display: flex;
            flex-direction: column;
        }

        .person {
            display: flex;
            flex-direction: column;
        }

        .person__name {
            font-family: 'YS Text', 'Arial', sans-serif;
            font-weight: 500;
            font-size: 12pt;
            line-height: 12pt;
        }

        .person__position {
            margin-top: calc(297 / 842 * 8mm);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-weight: 400;
            font-size: 9pt;
            line-height: 11pt;
        }

        .footer__date {
            margin-top: calc(297 / 842 * 38mm);

            font-family: 'YS Text', 'Arial', sans-serif;
            font-weight: 400;
            font-size: 10pt;
            line-height: 130%;
        }

        .footer__seal {
            position: absolute;

            height: calc(297 / 842 * 130mm);
            width: calc(210 / 595 * 130mm);

            top: calc(297 / 842 * -16mm);
            right: calc(210 / 595 * -16mm);
        }

        .seal {
            height: 100%;
            width: 100%;
        }

        .footer__signature {
            position: absolute;

            height: calc(297 / 842 * 92mm);
            width: calc(210 / 595 * 62mm);

            top: calc(297 / 842 * 20mm);
            right:  calc(210 / 595 * 25mm);
        }

        .signature {
            height: 100%;
            width: 100%;
        }

    </style>
</head>
<body>
<div class="page">
    <div class="page__background">
        <div class="page__paragraph page__paragraph_purple">
            <img class="paragraph paragraph_purple"
                 src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/paragraph-purple.svg">
        </div>
        <div class="page__line page__line_purple">
            <img class="line line_purple"
                 src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/line-purple.svg">
        </div>
        <div class="page__rectangle">
            <div class="page__paragraph page__paragraph_white">
                <img class="paragraph paragraph_white"
                     src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/paragraph-white.svg">
            </div>
            <div class="page__line page__line_white">
                <img class="line line_white"
                     src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/line-white.svg">
            </div>
        </div>
        <div class="page__pc">
            <img class="pc"
                 src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/pc-purple.svg">
        </div>
    </div>
    <div class="page__content content content__main">
        <div class="content__logo">
            <img class="logo"
                 src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/logo.svg"
                 alt="Яндекс Учебник">
        </div>
        <div class="content__title">
            Сертификат
        </div>
        <div class="content__subtitle">
            за участие в диагностике по информатике
        </div>
        <div class="content__personal-info personal-info">
            <div class="personal-info__name name">
                ${lastName ? `${lastName}` : ''}<br>
                ${firstName ? `${firstName}` : ''}<br>
                ${middleName ? `${middleName}` : ''}
            </div>
            <div class="personal-info__school school">
                ${schoolName ? `${schoolName}` : ''}
            </div>
        </div>
        <div class="content__description description">
            <div class="description__title">
                Поздравляем!
            </div>
            <div class="description__text">
                Вы успешно прошли диагностику<br>
                по информатике. Спасибо, что развиваете<br>
                современное образование вместе<br>
                с Яндекс Учебником.
            </div>
        </div>
        <div class="content__footer footer">
            <div class="footer__person person">
                <div class="person__name">А. М. Москвичев</div>
                <div class="person__position">
                    Руководитель сервиса Яндекс<br>Учебник
                </div>
            </div>
            <div class="footer__date">
                18 октября 2022 года
            </div>
            <div class="footer__seal">
                <img class="seal"
                     src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/yandex-seal.png"
                     alt="печать Яндекс Учебника">
            </div>
            <div class="footer__signature">
                <img class="signature"
                     src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/signature_moskvichev.svg"
                     alt="подпись Москвичева">
            </div>
        </div>
    </div>
</div>
</body>
</html>
`;
};
